import { lazy, ComponentProps } from 'react';

export type AssetsSubFolderType = 'dboo' | 'docTypes';
type IconProps = {
  name: string;
  subFolder?: AssetsSubFolderType;
};

export type LazySvgProps = ComponentProps<'svg'> & IconProps;
type LazyImportProps = IconProps & {
  folder: string;
};

const subFolderMap = {
  dboo: 'dboo',
  docTypes: 'document-types',
};

export function lazyImport({ name, subFolder, folder }: LazyImportProps) {
  const lazyIcon = lazy(async () => {
    try {
      /* import icons from brand specific folder */
      if (subFolder) {
        return await import(
          `../../assets/${folder}/${subFolderMap[subFolder]}/${name}.svg?react`
        );
      }
      return await import(`../../assets/${folder}/${name}.svg?react`);
    } catch (error) {
      /* import icons from common folder */
      if (subFolder) {
        return import(
          `../../assets/common/${subFolderMap[subFolder]}/${name}.svg?react`
        );
      }
      return import(`../../assets/common/${name}.svg?react`);
    }
  });

  return lazyIcon;
}
